import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      toastOptions={{
        duration: 3000,
        classNames: {
          toast:
              // Avoid backdrop-blur on the toast container to keep text crisp.
              "group toast group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-background/98 group-[.toaster]:to-background/95 group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-primary/30 group-[.toaster]:shadow-2xl group-[.toaster]:shadow-primary/20 group-[.toaster]:rounded-full group-[.toaster]:px-6 group-[.toaster]:py-3 group-[.toaster]:min-h-0",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-sm",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-full group-[.toast]:px-4 group-[.toast]:font-medium",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-full group-[.toast]:px-4",
          success: "group-[.toaster]:border-emerald-500/40 group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-emerald-500/10 group-[.toaster]:to-green-500/5 group-[.toaster]:text-emerald-700 dark:group-[.toaster]:text-emerald-400",
          error: "group-[.toaster]:border-red-500/40 group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-red-500/10 group-[.toaster]:to-rose-500/5 group-[.toaster]:text-red-700 dark:group-[.toaster]:text-red-400",
          info: "group-[.toaster]:border-primary/40 group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-primary/10 group-[.toaster]:to-yellow-500/5",
          warning: "group-[.toaster]:border-amber-500/40 group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-amber-500/10 group-[.toaster]:to-orange-500/5 group-[.toaster]:text-amber-700 dark:group-[.toaster]:text-amber-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
